import request from '../request';

export function index(params) {
  return request({
    url: "/manager/manage-deliveries",
    method: "get",
    params
  })
}

export function store(data) {
  return request({
    url: "/manager/manage-deliveries",
    method: "post",
    data
  })
}

export function update(data) {
  return request({
    url: `/manager/manage-deliveries/${data.id}`,
    method: "put",
    data
  })
}

export function show(id) {
  return request({
    url: `/manager/manage-deliveries/${id}`,
    method: "delete"
  })
}

export function delete_(id) {
  return request({
    url: `/manager/manage-deliveries/${id}`,
    method: "delete"
  })
}